import { render, staticRenderFns } from "./team.vue?vue&type=template&id=2fd799c2&scoped=true&"
var script = {}
import style0 from "./team.vue?vue&type=style&index=0&id=2fd799c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd799c2",
  null
  
)

export default component.exports